// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"b9f15a96","268":"349f0649","721":"aeeb0575","725":"a859e3a5","829":"f62f680c","975":"228acbf7"}[chunkId] + ".chunk.js";
};